import React from "react";
import "./CabBookingSkeleton.css"; 

const CabBookingSkeleton = () => {
  return (
    <div className="skeleton-wrapper">
      {/* Header */}
      <div className="skeleton-header"></div>

      {/* Booking Card */}
      <div className="skeleton-card">
        <div className="skeleton-carImage"></div>
        <div className="skeleton-route">
          <div className="skeleton-line short"></div>
          <div className="skeleton-line long"></div>
        </div>
        <div className="skeleton-features">
          <div className="skeleton-feature"></div>
          <div className="skeleton-feature"></div>
          <div className="skeleton-feature"></div>
        </div>
      </div>

      {/* Guest Table */}
      <div className="skeleton-table">
        <div className="skeleton-line"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line"></div>
      </div>

      {/* Fare Table */}
      <div className="skeleton-table small">
        <div className="skeleton-line"></div>
        <div className="skeleton-line"></div>
      </div>

      {/* Buttons */}
      <div className="skeleton-buttons">
        <div className="skeleton-btn"></div>
        <div className="skeleton-btn"></div>
        <div className="skeleton-btn"></div>
      </div>
    </div>
  );
};

export default CabBookingSkeleton;
